<h1 class="title">
  <svg-icon class="title-icon" src="/assets/icons/checkmark-empty-circle.svg"></svg-icon>
  <span>Take Action</span>
</h1>
<p class="description">
  These are Quests and Actions you've committed to. Form habits by completing them each day, and live more purposefully.
</p>
<ng-container *ngIf="cardBloc.takeActionCollection$ | async as collectionsStatus">
  <kp-take-action
    [isLoading]="collectionsStatus.status === status.starting"
    [cardScreen]="cardScreen"
    [cardCollections]="collectionsStatus?.data"></kp-take-action>
</ng-container>
